import React from 'react';
import { TextPlaceholderScenarioEntry } from './text-placeholder-api';
import { PlaceholderAutocompleteState } from './use-text-placeholder-autocomplete';
import styles from './inline-editor.module.css';

interface TextPlaceholderDropdownProps {
  state: PlaceholderAutocompleteState;
  onSelect: (key: string) => void;
  onCreate: () => void;
  onHover: (index: number) => void;
}

export function TextPlaceholderDropdown({
  state,
  onSelect,
  onCreate,
  onHover,
}: TextPlaceholderDropdownProps) {
  if (!state.open || !state.position) return null;

  const { top, left } = state.position;

  return (
    <ul
      className={styles.placeholderDropdown}
      style={{ top: `${top}px`, left: `${left}px` }}
      role="listbox"
      aria-label="Placeholders texte"
    >
      {state.filteredEntries.map((entry: TextPlaceholderScenarioEntry, index) => (
        <li key={entry.key}>
          <button
            type="button"
            role="option"
            aria-selected={state.selectedIndex === index}
            className={`${styles.placeholderDropdownItem} ${
              state.selectedIndex === index ? styles.placeholderDropdownItemActive : ''
            }`}
            onMouseDown={(event) => {
              event.preventDefault();
              onSelect(entry.key);
            }}
            onMouseEnter={() => onHover(index)}
          >
            <span className={styles.placeholderDropdownKey}>@{entry.key}</span>
            {entry.label ? (
              <span className={styles.placeholderDropdownLabel}>{entry.label}</span>
            ) : null}
            <span className={styles.placeholderDropdownValue}>
              {entry.value ?? 'non définie'}
            </span>
          </button>
        </li>
      ))}
      {state.showCreate ? (
        <li>
          <button
            type="button"
            role="option"
            aria-selected={state.selectedIndex === state.filteredEntries.length}
            className={`${styles.placeholderDropdownItem} ${styles.placeholderDropdownCreate} ${
              state.selectedIndex === state.filteredEntries.length
                ? styles.placeholderDropdownItemActive
                : ''
            }`}
            onMouseDown={(event) => {
              event.preventDefault();
              onCreate();
            }}
            onMouseEnter={() => onHover(state.filteredEntries.length)}
          >
            + Créer &quot;{state.query}&quot;
          </button>
        </li>
      ) : null}
      {state.filteredEntries.length === 0 && !state.showCreate ? (
        <li className={styles.placeholderDropdownEmpty}>Aucune clé trouvée</li>
      ) : null}
    </ul>
  );
}
